import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyCTfVZY2fL8HSzB0Iwo8TPOCGyrCx1Qktc",
  authDomain: "unresult.firebaseapp.com",
  databaseURL: "https://unresult.firebaseio.com",
  projectId: "unresult",
  storageBucket: "unresult.appspot.com",
  messagingSenderId: "1036877848254",
  appId: "1:1036877848254:web:76d497079b6b8ee41748ef",
  measurementId: "G-CG8F46H5XH"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getDatabase(app);

export { db };
